<script>
import Layout from '../../layouts/main';
import appConfig from '@/app.config';

export default {
  page: {
    title: 'Audit Log',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: 'Audit Log',
      items: [{ text: 'Settings' }, { text: 'Audit Log', active: true }],
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100],
      search: '',
      action: '',
      resource: '',
      success: '',
      selectedLog: null,
      fields: [
        { key: 'createdAt', label: 'Date & Time', sortable: false },
        { key: 'actor', label: 'Performed By' },
        { key: 'action', label: 'Action' },
        { key: 'resource', label: 'Module' },
        { key: 'path', label: 'Endpoint' },
        { key: 'status', label: 'Result' },
        { key: 'detail', label: 'Detail' }
      ]
    };
  },
  methods: {
    fetchLogs(ctx) {
      return this.$axios.get('/audit-log', {
        params: {
          page: ctx.currentPage,
          limit: ctx.perPage,
          search: this.search,
          action: this.action,
          resource: this.resource,
          success: this.success
        }
      }).then(response => {
        this.totalRows = response.data.result.total;
        return response.data.result.logs;
      });
    },
    refresh() {
      if (this.$refs.auditTable) this.$refs.auditTable.refresh();
    },
    formatDate(value) {
      return value ? new Date(value).toLocaleString('id-ID') : '-';
    },
    showDetail(log) {
      this.selectedLog = log;
      this.$bvModal.show('audit-detail-modal');
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">{{ title }}</h4>
            <div class="row mb-3">
              <div class="col-md-4 mb-2">
                <b-form-input v-model="search" placeholder="Search staff, email, endpoint..." @keyup.enter="refresh" />
              </div>
              <div class="col-md-2 mb-2">
                <b-form-select v-model="action" @change="refresh">
                  <option value="">All Actions</option>
                  <option value="CREATE">Create</option>
                  <option value="UPDATE">Update</option>
                  <option value="DELETE">Delete</option>
                </b-form-select>
              </div>
              <div class="col-md-2 mb-2">
                <b-form-input v-model="resource" placeholder="Module, e.g. user" @keyup.enter="refresh" />
              </div>
              <div class="col-md-2 mb-2">
                <b-form-select v-model="success" @change="refresh">
                  <option value="">All Results</option>
                  <option value="true">Success</option>
                  <option value="false">Failed</option>
                </b-form-select>
              </div>
              <div class="col-md-2 mb-2">
                <b-button variant="primary" block @click="refresh">Apply Filter</b-button>
              </div>
            </div>

            <div class="table-responsive">
              <b-table
                ref="auditTable"
                :items="fetchLogs"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                show-empty
                empty-text="No audit activity found"
              >
                <template v-slot:cell(createdAt)="data">{{ formatDate(data.item.createdAt) }}</template>
                <template v-slot:cell(actor)="data">
                  <div>{{ data.item.actor && (data.item.actor.name || data.item.actor.email) || 'System / Guest' }}</div>
                  <small class="text-muted">{{ data.item.actor && data.item.actor.role || '-' }}</small>
                </template>
                <template v-slot:cell(action)="data">
                  <b-badge :variant="data.item.action === 'DELETE' ? 'danger' : (data.item.action === 'CREATE' ? 'success' : 'info')">
                    {{ data.item.action }}
                  </b-badge>
                </template>
                <template v-slot:cell(status)="data">
                  <b-badge :variant="data.item.success ? 'success' : 'danger'">
                    {{ data.item.success ? 'Success' : 'Failed' }} ({{ data.item.statusCode }})
                  </b-badge>
                </template>
                <template v-slot:cell(detail)="data">
                  <b-button size="sm" variant="outline-primary" @click="showDetail(data.item)">View</b-button>
                </template>
              </b-table>
            </div>

            <div class="row align-items-center">
              <div class="col-sm-6">
                <b-form-select v-model="perPage" :options="pageOptions" size="sm" class="w-auto" />
              </div>
              <div class="col-sm-6">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" class="mb-0" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="audit-detail-modal" title="Audit Log Detail" size="lg" hide-footer>
      <div v-if="selectedLog">
        <p><strong>Path:</strong> {{ selectedLog.method }} {{ selectedLog.path }}</p>
        <p><strong>IP Address:</strong> {{ selectedLog.ipAddress || '-' }}</p>
        <p><strong>Resource ID:</strong> {{ selectedLog.resourceId || '-' }}</p>
        <pre class="audit-json">{{ JSON.stringify(selectedLog.changes, null, 2) }}</pre>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
.audit-json {
  max-height: 420px;
  overflow: auto;
  padding: 16px;
  background: #f6f8fa;
  border-radius: 6px;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
